export const contactSupportConstants = {
	MESSAGE_CONTACT_SUPPORT_REQUEST: 'MESSAGE_CONTACT_SUPPORT_REQUEST',
	MESSAGE_CONTACT_SUPPORT_SUCCESS: 'MESSAGE_CONTACT_SUPPORT_SUCCESS',
	MESSAGE_CONTACT_SUPPORT_FALIURE: 'MESSAGE_CONTACT_SUPPORT_FALIURE'
};
